import {
  clearMissingVariants,
  resetChanges,
  setChanges,
  setMissingVariants,
} from '../actions/inventoryPricingActions';
import inventoryPricingState from '../states/inventoryPricingState';
import { createUndoableSlice } from '../utils/undoable';

export const inventoryPricingSlice = createUndoableSlice({
  name: 'inventoryPricing',
  initialState: inventoryPricingState,
  reducers: {},
  undoableFields: {
    changes: true,
    missingVariants: false,
  },
  extraReducers: (builder) => {
    builder.addCase(setChanges, (state, action) => ({
      ...state,
      changes: action.payload
        ? {
            ...state.changes,
            ...Object.keys(action.payload).reduce(
              (acc, key) => ({
                ...acc,
                ...{
                  [key]: {
                    ...(state.changes?.[key] || {}),
                    ...action.payload[key],
                  },
                },
              }),
              {}
            ),
          }
        : undefined,
    }));

    builder.addCase(resetChanges, (state) => {
      return {
        ...state,
        changes: undefined,
      };
    });

    builder.addCase(setMissingVariants, (state, action) => {
      return {
        ...state,
        missingVariants: action.payload || [],
      };
    });

    builder.addCase(clearMissingVariants, (state) => ({
      ...state,
      missingVariants: [],
    }));
  },
});
